import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {TInspections} from '../types/types'
const initialState:
    {
        Inspections: TInspections[]

    } = {
    Inspections: []
}

const Inspections = createSlice({
    name: 'inspections',
    initialState,
    reducers: {
        addInspections: (state, action: PayloadAction<TInspections[]>) => {
            state.Inspections = action.payload
        },
        addSingleInspection: (state, action: PayloadAction<TInspections>) => {
            state.Inspections.push(action.payload);
        },
    },
});

export const { addInspections, addSingleInspection } = Inspections.actions;

export default Inspections.reducer;
